import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Check if fbq already exists
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      // Meta Pixel Code - simplified version
      ;
      (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        // Safely append to head instead of using parentNode
        b.head.appendChild(t);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '2384239302027188');
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <noscript data-id="element-206">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=2384239302027188&ev=PageView&noscript=1" alt="" data-id="element-207" />
    </noscript>;
}